import { Component, OnInit, ViewChildren, QueryList, Input } from '@angular/core';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
import { CommonConstants } from 'src/app/common/utilities/commonConstants';
import { DrawerComponent } from 'src/app/common/utilities/drawer/drawer.component';
import { NeedHelpService } from '../../services/needHelp.service';


@Component({
  selector: 'app-need-help-drawer',
  templateUrl: './need-help-drawer.component.html',
  styleUrls: ['./need-help-drawer.component.scss']
})
export class NeedHelpDrawerComponent implements OnInit {
  @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
  @Input() disabled: boolean;
  isDrawerOpen: boolean;

  constructor(
    public _needHelpService: NeedHelpService,
    private _sessionHandlerService: SessionHandlerService
  ) { }

  ngOnInit(): void {

  }
  public clickToCall() {
    const requestData = {
      payload: {
        'leadType': 'dropoff',
        'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
      },
    };
    this._needHelpService.PostClickToCall(requestData).subscribe((response) => {
      if (response && !response.error && response.payload) {
      } else {
      }
    },
      () => {
      });
  }
  public openDrawer(itemId) {
    this._needHelpService.setHelpDrawerEvent('open');
  }
  // close drawer
  public hideDrawer(itemId) {
    this._needHelpService.setHelpDrawerEvent('close');
  }
}
